import React from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Button from "components/Button";
import Tr from "translations/Translations";

const style = theme => ({
    root: {
        '& > *': {
            marginLeft: theme.spacing(1),
        },
        whiteSpace: 'nowrap',
    }
})

function ExportJedzButtons(
    {
        classes,
        dealingId,
        demandId,
        setConfirmPopupData,
    }) {

    const exportPdfClick = () => {
        setConfirmPopupData({open: true, dealingId, demandId, type: 'pdf'})
    };

    const exportXmlClick = () => {
        setConfirmPopupData({open: true, dealingId, demandId, type: 'xml'})
    };

    return (<div className={classes.root}>
            <Button
                onClick={exportPdfClick}
                variant="outlined"
                size='small'
                tooltip={Tr('export_to_pdf')}
            >
                pdf
            </Button>
            <Button
                onClick={exportXmlClick}
                variant="outlined"
                size='small'
                tooltip={Tr('export_to_xml')}
            >
                xml
            </Button>

        </div>)
}

ExportJedzButtons.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(ExportJedzButtons);